<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card class="p-2" :no-shadow="noShadow" :card-border="cardBorder">
		<div class="flex flex-row justify-start">
			<div class="flex items-center justify-center" style="min-height: 150px">
				<img
					v-if="checkImg"
					:src="item.url_logo"
					alt="user-profile-cover"
					class="logo responsive item-center"
					:title="item.description"
				/>
				<vs-avatar v-else class="mx-auto mb-6 block" size="120px" :title="item.description" :text="item.name" />
			</div>

			<div style="width: 100%" class="ml-base">
				<div>
					<h5 class="font-medium truncate">{{ item.name }}</h5>
					<p class="truncate mt-2">{{ (item.city + " - " + item.address) | capitalize }}</p>
					<p>{{ item.description }}</p>
				</div>

				<div class="flex justify-between flex-wrap mt-4">
					<span>
						<span class="text-xl">{{ $t("Resource.Resources") }}: </span>
						<span class="text-grey" v-if="!item.resource_typology_id">{{ item.total_resources }}</span>
						<p class="text-grey" v-if="!item.total_resources">{{ $t("Resource.NotResources") }}</p>
					</span>
					<div>
						<vs-chip v-if="item.has_sitidata" color="success"> Sitidata </vs-chip>
						<vs-chip v-if="item.has_serviroutes" color="success"> Serviroutes </vs-chip>
					</div>
				</div>

				<div class="mt-4">
					<div class="flex justify-between">
						<small class="font-semibold">{{ $t("CompanyModule.MissingServiceTime") }}</small>
						<small class="font-semibold text-grey">{{ missingTimeText(missingTime) }}</small>
					</div>
					<vs-progress
						:percent="percentage"
						class="block mt-1 shadow-md"
						:color="percentageColor(percentage)"
					></vs-progress>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			required: true,
		},
		noShadow: {
			type: Boolean,
			default: true,
		},
		cardBorder: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		percentageColor() {
			return function (percent) {
				return percent > 99 ? "danger" : percent >= 0 && percent <= 80 ? "success" : "warning";
			};
		},
		percentage() {
			// Set the start and end dates
			const startDate = new Date(this.item.date_init);
			const endDate = new Date(this.item.date_end);

			// Get the total time difference in milliseconds
			const totalTime = endDate.getTime() - startDate.getTime();

			// Get the time difference from the start date to the current date in milliseconds
			const currentTime = new Date().getTime() - startDate.getTime();

			// Calculate the percentage of time that has elapsed
			const percentElapsed = (currentTime / totalTime) * 100;

			return percentElapsed;
		},
		missingTime() {
			// Set the start and end dates
			const startDate = new Date(this.item.date_init);
			const endDate = new Date(this.item.date_end);

			// Calculate the time difference in milliseconds
			const timeDiff = endDate.getTime() - startDate.getTime();

			// Calculate the number of days between the two dates
			const totalDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

			// Calculate the number of months between the two dates
			const totalMonths = Math.ceil(timeDiff / (1000 * 3600 * 24 * 30.44));

			// Get the current date
			const today = new Date();

			// Calculate the time difference in milliseconds from the start date to today
			const missingTime = endDate.getTime() - today.getTime();

			// Calculate the number of missing days
			const missingDays = Math.ceil(missingTime / (1000 * 3600 * 24));

			// Calculate the number of missing months
			const missingMonths = Math.ceil(missingTime / (1000 * 3600 * 24 * 30.44));

			return {
				totalMonths,
				missingMonths,
				missingDays,
				totalDays,
			};
		},
		missingTimeText() {
			return function (missingTime) {
				if (missingTime.missingDays > 0 && missingTime.missingDays <= 60) {
					const days = missingTime.missingDays;
					return days > 1
						? missingTime.missingDays + " " + this.$t("CompanyModule.Days")
						: missingTime.missingDays + " " + this.$t("CompanyModule.Day");
				} else if (missingTime.missingDays > 60 && missingTime.missingDays <= 365) {
					return missingTime.missingMonths + " " + this.$t("CompanyModule.Months");
				} else if (missingTime.missingDays > 365) {
					const years = missingTime.missingMonths / 12;
					return years > 1
						? years.toFixed(1) + " " + this.$t("CompanyModule.Years")
						: years.toFixed(1) + " " + this.$t("CompanyModule.Year");
				} else if (missingTime.missingDays <= 0) {
					return 0;
				}
			};
		},
		checkImg() {
			return Object.hasOwnProperty.call(this.item, "url_logo") && this.item.url_logo;
		},
	},
	methods: {
		createSitidata() {
			this.$router
				.push({name: "app-setting", params: {company_id: this.item.id, config_type: "SITIDATA"}})
				.catch(() => {});
		},
		goToConfig() {
			this.$router
				.push({name: "app-setting", params: {company_id: this.item.id, config_type: "LIST"}})
				.catch(() => {});
		},
		getSessions() {
			this.$store
				.dispatch("moduleSessionApi/getSessionsApiByCompany", this.item.id)
				.then((response) => response)
				.catch((error) => console.error(error));
		},
		handleAccessToken() {
			this.manageAccessToken(this.item);
			this.getSessions();
		},
	},
};
</script>

<style lang="scss" scoped>
.logo {
	width: 120px;
	height: auto;
}
</style>
